import type { JSX } from "react";
import { Button, Grid } from "@mui/material";
import { FormattedMessage, MessageDescriptor } from "react-intl";

type GridColumns = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface IProps {
    closeBtnTxt?: string | MessageDescriptor | JSX.Element;
    submitBtnTxt?: string | MessageDescriptor | JSX.Element;
    onCloseBtn?: () => void;
    onSubmitBtn?: () => void;
    closeBtnDisabled?: boolean;
    submitBtnDisabled?: boolean;
    gridXSRejectButton?: GridColumns;
    gridXSSubmitButton?: GridColumns;
    gridMDRejectButton?: GridColumns;
    gridMDSubmitButton?: GridColumns;
}

function renderBtnTxt(title) {
    switch (typeof title) {
        case "string":
            return title;
        case "object":
            if (Object.hasOwn(title, "id") && Object.hasOwn(title, "defaultMessage")) {
                return <FormattedMessage {...title} />;
            }

            return title;
        default:
            return null;
    }
}

const FlyInDrawerFooter = ({
    closeBtnTxt,
    submitBtnTxt,
    onCloseBtn,
    onSubmitBtn,
    closeBtnDisabled,
    submitBtnDisabled,
    gridXSRejectButton,
    gridXSSubmitButton,
    gridMDRejectButton,
    gridMDSubmitButton,
}: IProps) => {
    const showRejectBtn = onCloseBtn ? (
        <Button
            fullWidth
            onClick={onCloseBtn}
            color="error"
            disabled={closeBtnDisabled}
            sx={{
                color: closeBtnTxt ? "ink.soft" : null,
                fontWeight: 600,
                borderRadius: "1.25rem",
            }}
        >
            {(closeBtnTxt && renderBtnTxt(closeBtnTxt)) || <FormattedMessage id="common.button-label.reject" defaultMessage="Reject" />}
        </Button>
    ) : null;

    const showSubmitBtn = onSubmitBtn ? (
        <Button
            fullWidth
            disableElevation
            variant="contained"
            color="secondary"
            sx={{ fontWeight: 600, borderRadius: "1.25rem" }}
            onClick={onSubmitBtn}
            disabled={submitBtnDisabled}
        >
            {(submitBtnTxt && renderBtnTxt(submitBtnTxt)) || <FormattedMessage id="common.button-label.submit" defaultMessage="Submit" />}
        </Button>
    ) : null;

    return (
        <Grid
            container
            direction="row"
            sx={{
                alignItems: "center",
                justifyContent: "space-evenly",
                position: "sticky",
                bottom: 0,
                bgcolor: "softSilver.main",
                padding: "15px 30px",
            }}
        >
            {showRejectBtn && <Grid size={{ xs: gridXSRejectButton || 5, md: gridMDRejectButton || 5 }}>{showRejectBtn}</Grid>}
            {showSubmitBtn && <Grid size={{ xs: gridXSSubmitButton || 5, md: gridMDSubmitButton || 5 }}>{showSubmitBtn}</Grid>}
        </Grid>
    );
};

export default FlyInDrawerFooter;
